import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAuth } from "../../context/AuthContext";
import { doc, getDoc, setDoc } from "../../api";
import { db } from "../../api";

export default function Profile() {
  const { currentUser } = useAuth();
  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    // Fetch existing profile data from Firestore
    const fetchProfile = async () => {
      if (!currentUser) return;
      const docRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        reset(docSnap.data());
      }
    };
    fetchProfile();
  }, [currentUser, reset]);

  const onSubmit = async (data) => {
    try {
      if (!currentUser) return;
      await setDoc(doc(db, "users", currentUser.uid), data, { merge: true });
      alert("Profile updated successfully!");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-customWhite flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded shadow p-6">
        <h2 className="text-burgundy text-2xl font-semibold mb-6">Profile</h2>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col space-y-4"
        >
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">Age:</label>
            <input
              type="number"
              {...register("age")}
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">
              Weight (lbs or kg):
            </label>
            <input
              type="number"
              {...register("weight")}
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">
              Height (ft/in or cm):
            </label>
            <input
              type="text"
              {...register("height")}
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">Birthday:</label>
            <input
              type="date"
              {...register("birthday")}
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">Shoe Size:</label>
            <input
              type="text"
              {...register("shoeSize")}
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          {/* Add more fields as needed */}
          <button
            type="submit"
            className="bg-burgundy text-white py-2 rounded hover:bg-opacity-90 transition"
          >
            Update Profile
          </button>
        </form>
      </div>
    </div>
  );
}
